import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './i18n';
import { AuthCallback } from './components/AuthCallback';
import { ProtectedRoute } from './components/ProtectedRoute';
import { TopBar } from './components/TopBar';
import { BottomNav } from './components/BottomNav';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Analyze from './pages/Analyze';
import Result from './pages/Result';
import Library from './pages/Library';
import Pitch from './pages/Pitch';
import PitchCompare from './pages/PitchCompare';
import Academy from './pages/Academy';
import CourseDetail from './pages/CourseDetail';
import CoachStudio from './pages/CoachStudio';
import BecomeCoach from './pages/BecomeCoach';
import Admin from './pages/Admin';
import PaymentResult from './pages/PaymentResult';
import Settings from './pages/Settings';
import './App.css';

const Shell = ({ children, noPad }) => (
  <div className="min-h-screen">
    <TopBar />
    <main className={noPad ? '' : 'max-w-6xl mx-auto px-4 sm:px-6 pb-28 pt-4'}>{children}</main>
    <BottomNav />
  </div>
);

const P = ({ children, noPad }) => (
  <ProtectedRoute>
    <Shell noPad={noPad}>{children}</Shell>
  </ProtectedRoute>
);

function AppRouter() {
  const location = useLocation();

  // Check URL fragment synchronously during render - prevents race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<P><Dashboard /></P>} />
      <Route path="/analyze" element={<P><Analyze /></P>} />
      <Route path="/result/:id" element={<P><Result /></P>} />
      <Route path="/library" element={<P><Library /></P>} />
      <Route path="/pitch" element={<P noPad><Pitch /></P>} />
      <Route path="/pitch/compare" element={<P><PitchCompare /></P>} />
      <Route path="/academy" element={<P><Academy /></P>} />
      <Route path="/course/:id" element={<P><CourseDetail /></P>} />
      <Route path="/coach" element={<P><CoachStudio /></P>} />
      <Route path="/become-coach" element={<P><BecomeCoach /></P>} />
      <Route path="/admin" element={<P><Admin /></P>} />
      <Route path="/settings" element={<P><Settings /></P>} />
      <Route path="/payment/success" element={<P><PaymentResult kind="success" /></P>} />
      <Route path="/payment/cancel" element={<P><PaymentResult kind="cancel" /></P>} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
